// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".std-prescription-tabs-info[data-v-728b0744] {\n  height: 50vh;\n}\n.button-action .option-label[data-v-728b0744] {\n  padding: 0 12px;\n}\n.button-action .option-btn[data-v-728b0744] {\n  width: 26px;\n  height: 26px;\n  color: #409EFF;\n  padding: 3px 0;\n  margin-top: 3px;\n}\n.button-action .option-large-btn[data-v-728b0744] {\n  width: 28px;\n  height: 28px;\n  color: #409EFF;\n  padding: 3px 0;\n  margin-top: 3px;\n}", ""]);
// Exports
module.exports = exports;
